import { h, FunctionComponent } from 'preact';
import { withTheme } from 'styled-components';
import { WidgetConfigs } from 'interfaces/WidgetConfigs.interface';

import { useTranslation } from 'react-i18next';
import Link from '../Link';
import {
  Container,
  Image,
  ImageWrapper,
  ContactSupportIconWrapper,
  ContactSupportIcon,
} from './MarketingCollateral.styles';
import contactSupportSVG from '../../icons/contact.svg';

interface MarketingCollateralProps {
  theme: WidgetConfigs;
}

const MarketingCollateral: FunctionComponent<MarketingCollateralProps> = ({
  theme,
}) => {
  const { t } = useTranslation();
  const { marketingCollateralBox, footerBox } = theme.configs;

  const hasNoMarketingCollateralBox =
    !marketingCollateralBox ||
    marketingCollateralBox.length === 0 ||
    marketingCollateralBox.every((item) => !item.bgImage);

  if (hasNoMarketingCollateralBox) return null;

  return (
    <Container>
      {marketingCollateralBox.map((image, index) => {
        return (
          image.bgImage && (
            // eslint-disable-next-line
            <ImageWrapper key={index}>
              <Link url={image.destinationURL}>
                <Image
                  data-testid="mc-image"
                  src={image.bgImage}
                  alt={image.altText}
                />
              </Link>
            </ImageWrapper>
          )
        );
      })}

      {!!footerBox.customerServiceURL && (
        <Link
          url={footerBox.customerServiceURL}
          ariaLabel={t('ALT_TEXT_FOOTER_CUSTOMER_SERVICE_LINK')}
        >
          <ContactSupportIconWrapper data-testid="mc-support-icon-wrapper">
            <ContactSupportIcon src={contactSupportSVG} aria-hidden />
          </ContactSupportIconWrapper>
        </Link>
      )}
    </Container>
  );
};

export default withTheme(MarketingCollateral);
